{
  "All Invoices": "Alle Rechnungen — {{name}}",
  "View Invoice": "Rechnung ansehen",
  "invoices_one": "{{count}} Rechnung",
  "invoices_other": "{{count}} Rechnungen",
  "You currently don't have any invoices here": "Derzeit haben Sie hier keine Rechnungen",
  "Back": "Zurück"
}
